// extracted by mini-css-extract-plugin
export default {"submenuItemList":"SubmenuItemList_submenuItemList__K4WTE"};